// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-container[data-v-1c8c93e3]{display:flex}.radio-container.horizontal[data-v-1c8c93e3]{justify-content:stretch;flex-direction:row}.radio-container.horizontal .button[data-v-1c8c93e3]{margin-right:15px}.radio-container.vertical[data-v-1c8c93e3]{align-items:stretch;flex-direction:column}.radio-container.vertical .button[data-v-1c8c93e3]{margin-bottom:15px}.button[data-v-1c8c93e3]:last-of-type{margin-bottom:0!important;margin-right:0!important}", ""]);
// Exports
module.exports = exports;
